// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"225":"LawyerLicenseVerification","694":"JudicalVerification"}[chunkId] || chunkId) + "." + {"225":"cc828bc7","593":"95dabb88","694":"d3d4f68f"}[chunkId] + ".css";
};